import styled from "styled-components";
import { colors, font, radius, shadow } from "../../../styles/theme/tokens";

export const Banner = styled.section`
  position: relative;
  display: flex;
  align-items: center;
  gap: 18px;
  max-width: 1120px;
  margin-bottom: 24px;
  padding: 22px 24px;
  border-radius: ${radius.xl};
  font-family: ${font.text};
  color: #FFFFFF;
  background:
    radial-gradient(60% 140% at 0% 0%, rgba(244, 182, 63, 0.35) 0%, rgba(244, 182, 63, 0) 60%),
    linear-gradient(120deg, ${colors.brandDark} 0%, ${colors.brandDeep} 60%, ${colors.brand} 100%);
  box-shadow: ${shadow.raised};

  @media (max-width: 900px) {
    flex-direction: column;
    align-items: flex-start;
    padding: 20px 18px;
  }
`;

export const Close = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  display: grid;
  place-items: center;
  width: 30px;
  height: 30px;
  border: none;
  border-radius: 50%;
  color: rgba(255, 255, 255, 0.8);
  background: transparent;
  cursor: pointer;

  &:hover {
    background: rgba(255, 255, 255, 0.16);
  }
`;

export const Icon = styled.span`
  display: grid;
  place-items: center;
  flex-shrink: 0;
  width: 60px;
  height: 60px;
  border-radius: 20px;
  color: ${colors.brandDark};
  background: ${colors.amber};
  box-shadow: 0 8px 20px rgba(244, 182, 63, 0.4);
`;

export const Text = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  flex: 1;
  min-width: 0;

  h3 {
    font-size: 20px;
    font-weight: 800;
  }

  p,
  ul {
    font-size: 14px;
    line-height: 1.5;
    color: rgba(255, 255, 255, 0.85);
  }

  ul {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin: 0;
    padding-left: 18px;
  }

  li {
    display: list-item;
    list-style: disc;
  }

  b {
    color: #FFFFFF;
  }
`;

export const Badge = styled.span`
  padding: 3px 10px;
  border-radius: ${radius.pill};
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: ${colors.brandDark};
  background: ${colors.amber};
`;

export const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  flex-shrink: 0;
  margin-right: 24px;

  @media (max-width: 900px) {
    margin-right: 0;
  }
`;

export const Light = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 11px 16px;
  border: none;
  border-radius: ${radius.md};
  font-family: ${font.text};
  font-size: 14px;
  font-weight: 800;
  color: #FFFFFF;
  background: rgba(255, 255, 255, 0.16);
  cursor: pointer;

  &:hover {
    background: rgba(255, 255, 255, 0.26);
  }
`;

export const Accent = styled(Light)`
  color: ${colors.brandDark};
  background: ${colors.amber};
  box-shadow: ${shadow.button(colors.amberDeep)};

  &:hover {
    background: ${colors.amber};
  }

  &:active {
    transform: translateY(2px);
  }
`;
